export default "/images/why_work_with_us/community_trust.png";